import { render, staticRenderFns } from "./Updatesubscription.vue?vue&type=template&id=54d96566&"
import script from "./Updatesubscription.vue?vue&type=script&lang=js&"
export * from "./Updatesubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports